export { BarChart as default } from './BarChart';
